"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _itemSelector = _interopRequireDefault(require("../item-selector"));

var _contexts = require("./contexts");

var _boxLead = _interopRequireDefault(require("./box-lead"));

var _boxBody = _interopRequireDefault(require("./box-body"));

var _boxCtaButton = _interopRequireDefault(require("./box-cta-button"));

var _boxFooter = _interopRequireDefault(require("./box-footer"));

var _boxCredit = _interopRequireDefault(require("./box-credit"));

var _unlockButton = _interopRequireDefault(require("./unlock-button"));

require("./box.scss");

require("./box-dekoder.scss");

var _boxMonthlyCheck = _interopRequireDefault(require("./box-monthly-check"));

var _payment = _interopRequireDefault(require("../payment"));

var _collapseMe = _interopRequireDefault(require("./collapse-me"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Box = _ref => {
  let {
    boxProps,
    contentLockProps,
    isFeedbackShown
  } = _ref;
  const [isExpanded, setIsExpanded] = (0, _react.useState)(boxProps.expanded);

  const toggleExpanded = () => setIsExpanded(e => !e);

  const [itemSelector, amount] = (0, _itemSelector.default)(boxProps);
  const [monthlyCheckbox, isMonthly] = (0, _boxMonthlyCheck.default)(boxProps.key);
  const [paypalBtn, twingleWidget, onCtaClick] = (0, _payment.default)(amount, isFeedbackShown);
  const unlockButton = (0, _unlockButton.default)(contentLockProps, setIsExpanded);
  let stateClasses = `${isExpanded ? "expanded" : "collapsed"}`;
  stateClasses += `${contentLockProps[0] ? " content-lock-active" : ""}`;
  return /*#__PURE__*/_react.default.createElement(_contexts.Amount.Provider, {
    value: { ...amount,
      isMonthly
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `donation-encourager__gradient ${stateClasses}`
  }), /*#__PURE__*/_react.default.createElement("aside", {
    className: `donation-encourager ${stateClasses}`
  }, twingleWidget || /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_boxLead.default, {
    onClick: toggleExpanded,
    isExpanded: isExpanded
  }), /*#__PURE__*/_react.default.createElement(_collapseMe.default, {
    isExpanded: isExpanded
  }, /*#__PURE__*/_react.default.createElement(_boxBody.default, null), itemSelector, monthlyCheckbox, /*#__PURE__*/_react.default.createElement("p", {
    className: "donation-encourager__cta"
  }, /*#__PURE__*/_react.default.createElement(_boxCtaButton.default, {
    onClick: onCtaClick,
    isInactive: !!paypalBtn
  }), unlockButton), paypalBtn, /*#__PURE__*/_react.default.createElement(_boxFooter.default, null), /*#__PURE__*/_react.default.createElement(_boxCredit.default, null)))));
};

var _default = Box;
exports.default = _default;